import { render, staticRenderFns } from "./AppleLogin.vue?vue&type=template&id=3b40bc04&scoped=true"
import script from "./AppleLogin.vue?vue&type=script&lang=js"
export * from "./AppleLogin.vue?vue&type=script&lang=js"
import style0 from "./AppleLogin.vue?vue&type=style&index=0&id=3b40bc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b40bc04",
  null
  
)

export default component.exports